import React from 'react';
import * as S from './styles';
import logo from '../../assets/menucheff_icon.png'

const PaginaNaoEncontrada = () => {
  return (
    <S.Container>
      <S.Logo src={logo} alt="Logo" />
      <h1>404 - Página Não Encontrada</h1>
      <p>A página que você procura não existe ou foi movida.</p>
      <S.Button onClick={() => (window.location.href = '/')}>
        Voltar
      </S.Button>
    </S.Container>
    );
};

export default PaginaNaoEncontrada;
